import React, { useEffect, useState } from 'react';
import { Button, Card, CardContent, CardDescription, CardGroup, CardHeader, CardMeta, Form, Message, TextArea } from 'semantic-ui-react';
import SemanticDatepicker from 'react-semantic-ui-datepickers';
import './UpdateOrder.css';
import PhoneInput from 'react-phone-number-input/input';
import logo from '../../assets/images/logo.jpeg';

export default function UpdateOrder() {

  const [email, setEmail] = useState('');
  const [fetchedData, setFetchedData] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [showUpdateCard, setShowUpdateCard] = useState(false);
  const [telephone, setTelephone] = useState();
  const [responseStatus, setResponseStatus] = useState('');
  const [closeOrderMessage, setCloseOrderMessage] = useState(false);
  const [loading, setLoading] = useState(false);

  const [updateValues, setUpdateValues] = useState({
    address: '',
    city: '',
    state: '',
    postal_code: '',
    notes: '',
    delivaryDate: '',
  });

  const [restrictedDelivaryDays, setRestrictedDelivaryDays] = useState([]);

    useEffect(() => {
        getRestrictedDelivarydays();
    }, []);

    const getRestrictedDelivarydays = () => {
        setRestrictedDelivaryDays([]);

        var myHeaders = new Headers();
        myHeaders.append("X-Api-Key", "pzO64MHwos9GjYA3skzzQ56PUzQW6gfa33RARHHX");

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        fetch("https://1wywpjzrl0.execute-api.us-east-1.amazonaws.com/live/thinkingfoods/management/restricted-delivery-days/get", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result) {
                    result.forEach(element => {
                        const date = new Date(element.config_val);
                        const now = new Date();
                        const restrictedDate = `${now.getFullYear()}-${date.getMonth(element.config_val) + 1}-${date.getDate(element.config_val)}`;
                        setRestrictedDelivaryDays(
                            oldValues =>
                            ([...oldValues,
                            new Date(restrictedDate).getTime()
                            ]));
                    });
                }
            })
            .catch(error => {
                console.log('error', error);
            });
    };

  const formatDate = (date) => {
    var day = date.getDate();
    var month = date.getMonth() + 1;
    var year = date.getFullYear();
    var delivery = `${year}-${month}-${day}`;
    return delivery;
  };

  async function filterOpenOrders(results) {
    let oldArray = [...results];
    results.map((data, index) => {
      let deliveryDate = new Date(data.delivery_date);
      let tomorrow = new Date();
      let todayNoon = new Date();
      let now = new Date();
      todayNoon.setHours(12,0,0,0);
      deliveryDate.setHours(0,0,0,0);
      tomorrow.setHours(0,0,0,0);
      tomorrow.setDate(tomorrow.getDate()+1);
      if (data.status !== 'OPEN' || deliveryDate.getTime() < tomorrow.getTime() || (deliveryDate.getTime() == tomorrow.getTime() && todayNoon.getTime() < now.getTime())) {
        oldArray.splice(index, 1);
      }
    });
    setFetchedData(oldArray);
    return oldArray;
  }

  const fetchOrderDetails = () => {
    var myHeaders = new Headers();
    myHeaders.append('X-Api-Key', 'pzO64MHwos9GjYA3skzzQ56PUzQW6gfa33RARHHX');

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow',
    };
    fetch(`https://q4wegfqlhj.execute-api.us-east-1.amazonaws.com/dev/thinkingfoods/order/find/v2?email=${email}`, requestOptions)
      .then(response => response.json())
      .then(result => {
        filterOpenOrders(result).then(orders => {
          if (orders.length === 0) {
            setCloseOrderMessage(true);
            setTimeout(() => {
              setCloseOrderMessage(false);
            }, 4000);
          }
        });
      })
      .catch(error => console.log('error', error));
  };

  const DisplayDeliveries = () => {
    return (
      <CardGroup centered>
        {fetchedData.map((data) => {
          return (
            <Card key={data.id} onClick={() => {
              handleUpdateModel(data);
            }}>
              <CardContent>
                <CardHeader>{data.item_string} </CardHeader>
                <CardMeta><strong>{data.customer_name}</strong></CardMeta>
                <CardDescription>
                  <strong>Email: </strong>
                  {data.email}<br/>
                  {/* <strong>Created Date: </strong> */}
                  <strong>Fecha de creación: </strong>
                  {data.created_date}<br/>
                  {/* <strong>Delivary Date: </strong> */}
                  <strong>Fecha de entrega: </strong>
                  {data.delivery_date}<br/>
                </CardDescription>
              </CardContent>
            </Card>
          );
        })}
      </CardGroup>
    );
  };

  const handleUpdateModel = (data) => {
    setSelectedData(data);
    var newdate = new Date(data.delivery_date);
    setUpdateValues(oldValues => ({
      ...oldValues, address: data.shipping_address, city: data.city, state: data.state, postal_code: data.postal_code,
      notes: data.notes, delivaryDate: newdate,
    }));
    setTelephone(data.telephone);
    setShowUpdateCard(true);
  };

  const changeHandler = (e) => {
    setUpdateValues(oldValues => ({ ...oldValues, [e.target.name]: e.target.value }));
  };

  const patchOrder = () => {
    setLoading(true);
    var myHeaders = new Headers();
    myHeaders.append('X-Api-Key', 'pzO64MHwos9GjYA3skzzQ56PUzQW6gfa33RARHHX');
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('user_id', email);
    var raw = JSON.stringify({
      'shipping_address': updateValues.address,
      'city': updateValues.city,
      'state': updateValues.state,
      'postal_code': updateValues.postal_code,
      'notes': updateValues.notes,
      'delivery_date': formatDate(updateValues.delivaryDate),
      'telephone': telephone,
    });
    var requestOptions = {
      method: 'PATCH',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };
    fetch(`https://q4wegfqlhj.execute-api.us-east-1.amazonaws.com/dev/thinkingfoods/order/customer/update?id=${selectedData.id}`, requestOptions)
      .then(response => {
        if (response.status === 200) {
          setLoading(false);
          setShowUpdateCard(false);
          setResponseStatus('positive');
          setTimeout(() => {
            setResponseStatus('');
          }, 5000);
        } else {
          setLoading(false);
          setResponseStatus('negative');
          setTimeout(() => {
            setResponseStatus('');
          }, 5000);
        }
      })
      .catch(error => {
        console.log('error', error);
        setLoading(false);
        setShowUpdateCard(false);
        setResponseStatus('negative');
        setTimeout(() => {
          setResponseStatus('');
        }, 5000);
      });
  };

  return (
    <div>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '2%' }}>
        <img src={logo} alt="" width="200" height="100"/>
        <h4 style={{ fontStyle: 'italic' }}>"Una auténtica Revolución Saludabñe"</h4>
      </div>
      <Form className="search-order-form">
        <Card className="update-order-card">
          <CardHeader>
            {/* <h2>Search Order</h2> */}
            <h2>Búsqueda Pedidos</h2>
          </CardHeader>
          <CardContent>
            <h3>Busca Aquí tu Pedido</h3>
            <div className="search-fields">
              <Form.Field>
                <label>Email</label>
                <input placeholder='Email' value={email} type="email" onChange={(e) => {
                  setEmail(e.target.value);
                }}/>
              </Form.Field>
            </div>
            <div className="actions"><Button basic onClick={() => {
              fetchOrderDetails();
            }} color="blue">
              {/* <strong>Search</strong> */}
              <strong>Buscar</strong>
            </Button></div>
          </CardContent>
        </Card>
      </Form>
      {closeOrderMessage ?
        <div className="update-order-form">
          <Message warning>
            {/* <Message.Header>No orders were found.</Message.Header> */}
            <Message.Header>No se encontraron órdenes.</Message.Header>
          </Message></div> : <DisplayDeliveries/>}
      {showUpdateCard ? <Form className="update-order-form">
        <Card className="update-order-card">
          <CardHeader>
            {/* <h2>Update Order</h2> */}
            <h2>Actualización Pedido</h2>
          </CardHeader>
          <CardContent>
            <div className="search-fields">
              <Form.Field>
                {/* <label>Name</label> */}
                <label>Nombre</label>
                <input placeholder='Nombre' value={selectedData.customer_name} disabled type="text"/>
              </Form.Field>
              <Form.Field>
                {/* <label>Item</label> */}
                <label>Item</label>
                <input placeholder='Nombre del árticulo' value={selectedData.item_string} disabled type="text"/>
              </Form.Field>
            </div>
            <div className="search-fields">
              <Form.Field>
                <label>Email</label>
                <input placeholder='Email' value={selectedData.email} disabled type="email"/>
              </Form.Field>
              <Form.Field>
                {/* <label>New Delivary Date</label> */}
                <label>Nueva fecha de entrega</label>
                <SemanticDatepicker
                    datePickerOnly
                    showToday={false}
                    value={updateValues.delivaryDate}
                    onChange={(event, data) => {
                        setUpdateValues(oldValues => ({ ...oldValues, delivaryDate: data.value }));
                    }}
                    format="DD-MM-YYYY"
                    filterDate={(date) => {
                        const now = new Date();
                        return date > now.setDate(now.getDate() + 1) && date.getDay() !== 0 && date.getDay() !== 1 && date.getDay() !== 6 &&
                            !restrictedDelivaryDays.includes(date.getTime());
                    }}
                />
              </Form.Field>
            </div>
            <div className="search-fields">
              <Form.Field>
                {/* <label>Address</label> */}
                <label>Dirección</label>
                <input placeholder='Dirección' name="address" value={updateValues.address} type="text" onChange={(e) => {
                  changeHandler(e);
                }}/>
              </Form.Field>
              <Form.Field>
                {/* <label>City</label> */}
                <label>Ciudad</label>
                <input placeholder='Ciudad' name="city" value={updateValues.city} type="text" onChange={(e) => {
                  changeHandler(e);
                }}/>
              </Form.Field>
            </div>
            <div className="search-fields">
              <Form.Field>
                {/* <label>State</label> */}
                <label>Provincia</label>
                <input placeholder='Provincia' name="state" value={updateValues.state} type="text" onChange={(e) => {
                  changeHandler(e);
                }}/>
              </Form.Field>
              <Form.Field>
                {/* <label>Postal Code</label> */}
                <label>Código postal</label>
                <input placeholder='Código postal' name="postal_code" value={updateValues.postal_code} type="text" onChange={(e) => {
                  changeHandler(e);
                }}/>
              </Form.Field>
            </div>
            <div className="search-fields">
              <Form.Field>
                {/* <label>Telephone</label> */}
                <label>Teléfono</label>
                <PhoneInput placeholder="Introduzca el número de teléfono" value={telephone} onChange={setTelephone}/>
              </Form.Field>
              <Form.Field>
                {/* <label>New Description</label> */}
                <label>Nueva descripción</label>
                <TextArea placeholder="Descripción" value={updateValues.notes} onChange={(e) => {
                  setUpdateValues(oldValues => ({ ...oldValues, notes: e.target.value }));
                }}/>
              </Form.Field>
            </div>
            <div className="actions" style={{ marginTop: '15px' }}>
              <Button style={{ marginRight: '10px' }} onClick={() => {
                setShowUpdateCard(false);
              }} color="black">
                {/* <strong>Cancel</strong> */}
                <strong>Cancelar</strong>
              </Button>
              <Button onClick={() => {
                patchOrder();
              }} loading={loading} disabled={loading} color="linkedin">
                {/* <strong>Update</strong> */}
                <strong>Actualizar</strong>
              </Button>
            </div>
          </CardContent>
        </Card>
      </Form> : null}
      {responseStatus === '' ? null :
        <div className="update-order-form">
          {responseStatus === 'positive' ?
            <Message positive>
              {/* <Message.Header>Order is successfully updated.</Message.Header> */}
              <Message.Header>El pedido se actualizó correctamente.</Message.Header>
            </Message> :
            <Message negative>
              {/* <Message.Header>An error occured.</Message.Header> */}
              <Message.Header>Ocurrió un error.</Message.Header>
            </Message>
          }
        </div>
      }
    </div>
  );
}